import React, { useEffect, useState } from 'react';
import { Check, AlertTriangle, Info, X } from 'lucide-react';

export type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
  message: string;
  type: ToastType;
  onClose: () => void;
}

export const Toast: React.FC<ToastProps> = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const icons = {
    success: <Check className="w-4 h-4 text-green-500" />,
    error: <AlertTriangle className="w-4 h-4 text-red-500" />,
    info: <Info className="w-4 h-4 text-primary" />
  };

  const borders = {
    success: 'border-green-500/50',
    error: 'border-red-500/50',
    info: 'border-primary/50'
  };

  return (
    <div className={`flex items-center gap-3 px-4 py-3 bg-surface border ${borders[type]} rounded-lg shadow-2xl backdrop-blur-md animate-in slide-in-from-bottom-5 fade-in duration-300 min-w-[300px]`}>
      <div className={`p-1.5 rounded-full bg-background/50 border border-text/5`}>
        {icons[type]}
      </div>
      <p className="text-sm text-text font-medium flex-grow">{message}</p>
      <button onClick={onClose} className="text-subtext hover:text-text">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};